import { render, staticRenderFns } from "./SPContact.vue?vue&type=template&id=316f0f59&"
import script from "./SPContact.vue?vue&type=script&lang=ts&"
export * from "./SPContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports